import { Field } from 'redux-form';

import {
  SelectField,
  TextField,
  normalizeCreditCard
} from 'common/components/forms';
import { pad } from 'common/helpers/miscHelper';

const CreditCardForm = () => (
  <>
    <Field
      name="cardNumber"
      component={TextField}
      label="Card Number"
      normalize={normalizeCreditCard}
      required
    />
    <div className="c7-form__group">
      <Field
        name="expiryMo"
        component={SelectField}
        optionArray={expiryMoArray()}
        label="Expiry Mo"
        className="c7-form__cardexpiry-mm"
        required
      />
      <Field
        name="expiryYr"
        component={SelectField}
        optionArray={expiryYrArray()}
        label="Expiry Yr"
        className="c7-form__cardexpiry-yy"
        required
      />
      <Field
        name="cvv2"
        component={TextField}
        label="CVV"
        className="c7-form__cardexpiry-cvv"
        required
      />
    </div>
    <Field
      name="cardHolderName"
      component={TextField}
      label="Name On Card"
      required
    />
  </>
);

export default CreditCardForm;

const expiryMoArray = () => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  const optionArray = [{ value: '', option: '' }];
  for (let i = 1; i <= 12; i += 1) {
    optionArray.push({
      value: i.toString(),
      option: `${pad('00', i)}-${monthNames[i - 1]}`
    });
  }
  return optionArray;
};

const expiryYrArray = () => {
  const currentYear = new Date().getFullYear();
  const optionArray = [{ value: '', option: '' }];
  for (let i = currentYear; i <= currentYear + 10; i += 1) {
    optionArray.push({ value: i.toString(), option: i.toString() });
  }
  return optionArray;
};
